import { browserStorage } from "@/utils/browserStorage";
import type { TokenResponse } from "@/types";

const REALM_ACCESS_KEY_PREFIX = "exordos.realm.access_token.";
const REALM_REFRESH_KEY_PREFIX = "exordos.realm.refresh_token.";
const ACTIVE_REALM_KEY = "exordos.active_realm";

export function getRealmAccessToken(realmUuid: string): string | null {
  return browserStorage.get(`${REALM_ACCESS_KEY_PREFIX}${realmUuid}`);
}

export function getRealmRefreshToken(realmUuid: string): string | null {
  return browserStorage.get(`${REALM_REFRESH_KEY_PREFIX}${realmUuid}`);
}

export function storeRealmTokenResponse(
  realmUuid: string,
  tokenResponse: TokenResponse,
): string {
  browserStorage.set(
    `${REALM_ACCESS_KEY_PREFIX}${realmUuid}`,
    tokenResponse.access_token,
  );

  if (tokenResponse.refresh_token) {
    browserStorage.set(
      `${REALM_REFRESH_KEY_PREFIX}${realmUuid}`,
      tokenResponse.refresh_token,
    );
  } else {
    browserStorage.remove(`${REALM_REFRESH_KEY_PREFIX}${realmUuid}`);
  }

  return tokenResponse.access_token;
}

export function clearRealmAuthTokens(realmUuid: string): void {
  browserStorage.remove(`${REALM_ACCESS_KEY_PREFIX}${realmUuid}`);
  browserStorage.remove(`${REALM_REFRESH_KEY_PREFIX}${realmUuid}`);
}

export interface ActiveRealmData {
  uuid: string;
  domain: string;
  name: string;
}

export function getActiveRealm(): ActiveRealmData | null {
  const raw = browserStorage.get(ACTIVE_REALM_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ActiveRealmData;
  } catch {
    browserStorage.remove(ACTIVE_REALM_KEY);
    return null;
  }
}

export function setActiveRealm(data: ActiveRealmData): void {
  browserStorage.set(ACTIVE_REALM_KEY, JSON.stringify(data));
}

export function clearActiveRealm(): void {
  browserStorage.remove(ACTIVE_REALM_KEY);
}